<template>
  <div class="leco-content"></div>
</template>

<script>
import cognito from "@/cognito";
import { SET_AUTH } from "@/store/mutations.type";

export default {
  name: "sso-redirect",

  data() {
    return {
      logger: this.$store.state.logger,
      redirectUrl: sessionStorage.getItem("redirect_path") || "/"
    };
  },

  async created() {
    // スクロールトップ（Optional Chaining を使わない）
    if (typeof this.instantScrollTop === "function") {
      this.instantScrollTop();
    }

    try {
      // ① URL から authorization code を取得
      const code = new URLSearchParams(window.location.search).get("code");

      if (!code) {
        throw new Error("SSO redirect error: authorization code not found.");
      }

      this.logger.info("SSO redirect: code received");

      // ② Cognito OAuth token 取得 & sessionStorage に保存
      const session = await cognito.completeSsoLogin(code);

      // ③ Vuex に認証情報をセット
      this.$store.commit(SET_AUTH, session);

      this.logger.info("SSO login completed");

      // ④ 元の画面へ戻す
      this.$router.replace(this.redirectUrl);
    } catch (err) {
      this.logger.error("SSO redirect failed");
      this.logger.error(err);

      // 失敗時はログイン画面へ
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.leco-content {
  min-height: 1px;
}
</style>
